var _a;
export var CONDITION_FILTER_LABELS;
(function (CONDITION_FILTER_LABELS) {
    CONDITION_FILTER_LABELS["ALL"] = "ALL";
    CONDITION_FILTER_LABELS["ANY"] = "ANY";
    CONDITION_FILTER_LABELS["CUSTOM"] = "CUSTOM";
})(CONDITION_FILTER_LABELS || (CONDITION_FILTER_LABELS = {}));
export var CONDITION_FILTER_OPTIONS = (_a = {},
    _a[CONDITION_FILTER_LABELS.ALL] = 'All',
    _a[CONDITION_FILTER_LABELS.ANY] = 'Any',
    _a[CONDITION_FILTER_LABELS.CUSTOM] = 'Custom',
    _a);
export var CONDITION_FILTERS_OPERATOR_MAP = {
    All: 'and',
    Any: 'or',
};
export var OPERATORS_CONDITION_FILTERS_MAP = {
    and: 'All',
    or: 'Any',
};
export var EXPRESSION_PART = {
    COMPAREWITH: 'comp',
    OPERATOR: 'op',
    CONST: 'const',
};
export var SUPPORTED_PREDICATES = {
    BOOL: 'bool',
    DATE: 'dateTime',
    FLOAT: 'float',
    INT: 'int',
    STR: 'string',
};
export var SAVE_LOCATION_STATUSES;
(function (SAVE_LOCATION_STATUSES) {
    SAVE_LOCATION_STATUSES["SUCCESS"] = "success";
    SAVE_LOCATION_STATUSES["ERROR"] = "error";
    SAVE_LOCATION_STATUSES["LOADING"] = "loading";
    SAVE_LOCATION_STATUSES["INFO"] = "info";
})(SAVE_LOCATION_STATUSES || (SAVE_LOCATION_STATUSES = {}));
//# sourceMappingURL=types.js.map